import React ,{useRef ,useEffect}from 'react';
import './Budgeting.scss'
import IrtizaDynamicInputList from '../../software-dynamic-version-2/list-input-v-2';
import moment from 'moment'
import SecurityService from '../../security/security.service';
import BudgetingService from './Budgeting.service';
import BudgetingAdd from './Budgeting-add';
import DialogInput from '../../software-dynamic-version-2/popup-dialog-input-v-2';
import AuditTable from '../../audit-table/audit-table'



const BudgetingInput = (props) => {
  
    let columns =[
        {  field: "EntryID",headerText:'ID',width:'120px',textAlign:'right' ,headerTextAlign:'center',other:[]},
        {  field: "EntryDate",headerText:'Entry Date',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        {  field: "ExportOrderNo",headerText:'Export Order No',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
        {  field: "CustomerOrderNo",headerText:'Customer Order No',width:'130px',textAlign:'left' ,headerTextAlign:'center',other:[]},
        ]
        let detailsOfGrid = []
        const getDetails = (e)=>{
          console.log(e)
          detailsOfGrid = e
        }

        const listActionComplete = async (grid , args ,getListService ,selectedRow  ,setDataSourceState ,addUserLog,editUserLog)=>{
          console.log(args )
        console.log(getListService )
        console.log(selectedRow )
        if (args.requestType === 'beginEdit' || args.requestType === 'add') {
          }
        if (args.requestType == 'save' || args.requestType == 'cancel' ) {
          getListService()

        }

        if (args.requestType == 'save'  && args.action  == 'add' && detailsOfGrid.length > 0) {
          console.log(args)
          console.log(detailsOfGrid)
      
            BudgetingService.addWithDetail(
              {
                EntryID:args.data.EntryID,
                EntryDate:args.data.EntryDate,
                ExportOrderNo:args.data.ExportOrderNo,
                CreationDate:moment().format('DD-MMM-YY'),
                CreatedByUserID:SecurityService.getLoggedInUserId(),
                UpdationDate:null,
                UpdatedByUserID:null,
                PrintedByDate:null,
                PrintedByUserID:null,
                ApprovedByUserID:null,
                ApprovedByDate:null,
                CompanyID:1,
                details :detailsOfGrid,
                UpdatedByUserID:SecurityService.getLoggedInUserId()}).then((res)=>{
              console.log(res)
              
              getListService()
              addUserLog('BudgetingMain','BudgetingMain','EntryID',{
                EntryDate:moment(args.data.EntryDate).format('DD-MMM-YY'),
                CustomerOrderNo:args.data.CustomerOrderNo
              })
              detailsOfGrid.map((res)=>{
                addUserLog('BudgetingDetail','BudgetingDetail','BudgetingDetailID',{
                  BudgetItem: res.BudgetItem || '',
                  Quantity: res.Quantity || 0,
                  Rate: res.Rate || 0,
                  Percentage: res.Percentage || 0,
                  Amount: res.Amount || 0,
                  ActualAmount: res.ActualAmount || 0
                  
                })

              })

             
              }).catch((e)=>{
                console.log(e)
                getListService()
              })
          
        }

        
        if (args.requestType == 'save'  && args.action  == 'edit') {
          BudgetingService.updateBudgetingMain(
            {...args.data,  
              UpdationDate:moment().format('DD-MMM-YY'),
              UpdatedByUserID:SecurityService.getLoggedInUserId(),
            }).then((response)=>{
              console.log(response);
              editUserLog('BudgetingMain',args.data.EntryID,'EntryID',{
                EntryDate:moment(args.data.EntryDate).format('DD-MMM-YY'),
                CustomerOrderNo:args.data.CustomerOrderNo
              })
            })
        }
       }
       //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************
    //    ***************************************************************************************************************

        // Defines the  boolean
        // @default true
    let  allowTemplate = false
    let  allowGrouping = true
    let  allowExcelExport =true
    let  allowPdfExport = true
    let  showColumnChooser = true
    let  allowPaging = false
    let  allowDataBound = true
    let  allowGridSum = false

       
        // Defines the  string
        // @default Budgeting${typeMode} 
        let ListSecurity='Budgeting'
        let AddSecurity='Budgeting'
        let EditSecurity='Budgeting'
        let DeleteSecurity='Budgeting'
        let ReportSecurity='Budgeting'
       
       // Defines the  ['Add','Edit','Delete','Update','Cancel','PDFExport','ExcelExport','Search','ColumnChooser'] | 'All'
       //  @default 'All'
      let toolbarOptions =['Add','Edit',   
        {  text: `Delete`, tooltipText: "Delete", id: "DeleteWithDetail", disable:!SecurityService.canUserAccess('Budgeting')['Delete'] },        
        'Update','Cancel',
        {
          text: "Preview", tooltipText: "Preview", id: "BudgetingPreview", 
          disabled: !SecurityService.canUserAccess(ReportSecurity)
          ,mustSelectRow:true
          
       }
        ,'PDFExport','ExcelExport','Search','ColumnChooser'].filter(Boolean);
       ;
      


       const handleRedirectPreview = async (args) => {
         console.log(args)
         let reportServerPath = await SecurityService.ReportServerPath();
         console.log(reportServerPath);
        // Construct the URL with the parameters
        // http://asif-pc/ReportServer?
        // %2fHS%2fTowelERP%2fExport%2fExportBudgeting
        // &rs:Command=Render&rc:Toolbar=true&
        // FromDate=1/1/2001&ToDate=10/25/2024&ExportOrderNo=8&ACodeCustomer=&CountryID=0&PortID=0&ACodeBank=&LoomTypeID=0&InsuranceByID=0&ShipmentTypeID=0&ShipmentTermsID=0&ContractStatusID=0&MerchandizerID=0&ProductCategoryID=0&CreatedByUserID=0&UpdatedByUserID=0&PrintedByUserID=0&ApprovedByUserID=0&ProductID=0&ProductTypeID=0&FancyID=0&ProcessID=0&CurrencyID=0&ProcurementTypeID=0&RowSerialNo=0&BudgetCategoryID=0&BudgetItemID=0&BudgetingDetailID=0
//         const [year, month, day] =.split('T')[0].split('-');
// let entryDate = new Date(year, month - 1, day);

// Format the date to MM/DD/YY
let formattedDate =  args.EntryDate.toLocaleDateString('en-US', {
  year: '2-digit',
  month: '2-digit',
  day: '2-digit',
});

console.log(formattedDate);

        const url = `${reportServerPath}%2fHS%2fTowelERP%2fExport%2fExportBudgeting&rs:Command=Render&rc:Toolbar=true&FromDate=1/1/2001&ToDate=${formattedDate}&ExportOrderNo=${args.ExportOrderNo}&ACodeCustomer=${args.ACodeCustomer || ''}&CountryID=${args.CountryID || 0}&PortID=${args.PortID || 0}&ACodeBank=${args.ACodeBank || ''}&LoomTypeID=${args.LoomTypeID || 0}&InsuranceByID=${args.InsuranceByID || 0}&ShipmentTypeID=${args.ShipmentTypeID || 0}&ShipmentTermsID=${args.ShipmentTermsID || 0}&ContractStatusID=${args.ContractStatusID || 0}&MerchandizerID=${args.MerchandizerID || 0}&ProductCategoryID=${args.ProductCategoryID || 0}&CreatedByUserID=${args.CreatedByUserID || 0}&UpdatedByUserID=${args.UpdatedByUserID || 0}&PrintedByUserID=${args.PrintedByUserID || 0}&ApprovedByUserID=${args.ApprovedByUserID || 0}&ProductID=${args.ProductID || 0}&ProductTypeID=${args.ProductTypeID || 0}&FancyID=${args.FancyID || 0}&ProcessID=${args.ProcessID || 0}&CurrencyID=${args.CurrencyID || 0}&ProcurementTypeID=${args.ProcurementTypeID || 0}&RowSerialNo=${args.RowSerialNo || 0}&BudgetCategoryID=${args.BudgetCategoryID || 0}&BudgetItemID=${args.BudgetItemID || 0}&BudgetingDetailID=${args.BudgetingDetailID || 0}`;

        // Open the URL in a new tab and focus on it
        const newTab = window.open(url, '_blank');
        newTab.focus();
      };
      

       const dialogRef = useRef(null);
       const showDialog = (header,title,actions =['OK']) => {
         return new Promise((resolve) => {
         // Destroy existing dialog if any
         if (dialogRef.current) {
           dialogRef.current.destroy();
         }
         const okButtons = actions.map((action) => ({
           buttonModel: {
             content: action,
             cssClass: 'e-flat',
             isPrimary: action === 'OK',
           },
           click: (e) => {
             hideDialog();
             resolve(action);
           },
         }));
         // Create a new dialog instance
         dialogRef.current = new DialogInput({
           content: ()=>(<>{title}</>),
           header:header,
           width:'340px',
           showButtons: true,
           buttons:okButtons
         });
         // Show the dialog programmatically
         dialogRef.current.show();

       });

       };
     const hideDialog = () =>{
       if (dialogRef.current) {
       }
       dialogRef.current.hide();
       dialogRef.current.destroy();
       dialogRef.current = null; // Clean up reference after destruction
     }
      const toolbarClicking =  async (grid , args , selectedRow , getListService,setDataSourceState)=>{
        console.log(args)
        if(args?.item?.properties?.id == 'DeleteWithDetail'){
          if(selectedRow == undefined){
        await showDialog('WARNING' ,<span class="error-tooltip">Please select a row first!</span>)
      }else{
        let dialogResult  = await showDialog('Confirmation' ,<span class="error-success">Are you sure you want to delete?</span> , ['OK','CANCEL'])
        console.log(dialogResult)
      if(dialogResult == 'OK'){
        BudgetingService.delete(selectedRow.EntryID).then(async (res)=>{
        await  showDialog('ALERT' ,<span class="error-success">RECORD(S) DELETED SUCESSFULLY</span>)
          await getListService()
            AuditTable.auditDelete('UserInfo',selectedRow.EntryID,{
              EntryDate:moment(selectedRow.EntryDate).format('DD-MMM-YY'),
              CustomerOrderNo:selectedRow.CustomerOrderNo,
              
            })
          })
        }
        }
        }
        if(args?.item?.properties?.id == 'BudgetingPreview' && grid.selectedRowIndex != -1){
          
          console.log(grid.getSelectedRecords()[0])
          handleRedirectPreview(grid.getSelectedRecords()[0])
        
        }
       }
       // Defines the 'Descending' | 'Ascending'
       //  @default 'Descending'
      let DefaultSortedColumnSort ='Descending';

       /* Defines the [{
                    TableName:'Budgeting' ,
                    TableID:'BudgetingID',
                   // Optional if Delete is Soft // TableSecurity:'BudgetingDelete',
                }]*/
    //  @default [] 
    //   let listDelete =  [{ TableName:'Budgeting' ,TableID:'BudgetingID', Optional // TableSecurity:'BudgetingDelete'}]
    let listDelete =  [{ TableName:'BudgetingDetail' ,TableID:'EntryID'}];
       
    // Defines 'Hard' | 'Soft' 
    // @Default 'Hard'
    let deleteType = 'Hard'


/* Defines the [   {field:'IsDeleted',
OPTIONAL HAI operator:'equal' or more check syncfusion documentation
        value:'No'},...more
        ] | []
      @default [] */
    //   let filterColumns = [{ field: 'IsDeleted', value: 'No' }];
      let filterColumns = [];

      /* Defines the [ColumnNames] | []
      @default [] */
    //   let groupColumns = ['IsDeleted','AccountTitleHawalaDr'];
      let groupColumns = [];

/* Defines the 'Dialog' | 'Normal'
      @default 'Dialog' */
      let gridEditSettingMode = 'Dialog';

/* Defines the '<p></p>' | Can give HTML | AND REACT FUNCTION LIKE HeaderTemplate
      @default '<p></p>' */
      let gridEditSettingHeaderTemplate = '<p></p>';

      /* Defines the  [ColumnNames] | []
      @default [] */
           //   let gridSumColumns = ['HawalaCommissionPercent'];
      let gridSumColumns = [];


    return (
        <IrtizaDynamicInputList
        Id='Budgeting'
        ListTitle={`Budgeting  - List`}
        ColumnsList={columns}
        GridDataSource= {[
                    {
                        DataSourceType: 'Function',
                        DataSource:  ()=> BudgetingService.getBudgetingForList()
                        }]}
        DefaultSortedColumnName={'EntryID'}
        GridDialog={[
            {
                DialogType:'Self',
                // Dialog:<BudgetingAdd ShopID={SecurityService.getLoggedInUserId() == 0 ? SecurityService.getLoggedInUserId() : SecurityService.getLoggedInShopID()} />
                Dialog:<BudgetingAdd  GridID = {'Budgeting'} sendDetails={getDetails}/>
                // Dialog:<BudgetingAdd ShopID={1} /> 
                }
        ]}
        ListActionComplete={listActionComplete}
        ToolbarClicking ={toolbarClicking}

        //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
            AllowTemplate={allowTemplate}
            ToolbarOption={toolbarOptions}
            // AllowGrouping={allowGrouping}
            // AllowExcelExport={allowExcelExport}
            // AllowPdfExport={allowPdfExport} 
            // ShowColumnChooser={showColumnChooser}
            // AllowPaging={allowPaging}
            AllowDataBound={allowDataBound}
            // ListSecurity={ListSecurity}
            // AddSecurity={AddSecurity}
            // EditSecurity={EditSecurity}
            // DeleteSecurity={DeleteSecurity}
            DefaultSortedColumnSort={DefaultSortedColumnSort}
            // FilterColumns={filterColumns} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
            // GroupColumns={groupColumns} 
            // ListDelete={listDelete}
            // DeleteType={deleteType} 
            // GridEditSettingMode={gridEditSettingMode}
            // GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
            // GridSumColumns={gridSumColumns}
            AllowGridSum={allowGridSum}
            {...props}
            ></IrtizaDynamicInputList>
            
            );
}



export default BudgetingInput;
